import Tabs from "components/EvtKit/tabs/Tabs"
import TabsContent from "components/EvtKit/tabs/TabsContent"
import { ReactNode, memo } from "react"
import styled from "styled-components"
import TabsListGradient from "components/EvtKit/tabs/tabsGradient/TabsListGradient"
import TabsTriggerGradient from "components/EvtKit/tabs/tabsGradient/TabsTriggerGradient"

const PricingContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 32px;
`

const TabsListContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  height: 40px;
`

const tabIds = {
  expression: "expression",
  calculator: "calculator"
}

interface PricingVariableTabsProps {
  pricingCalculator: ReactNode
  pricingExpression: ReactNode
}

const PricingVariableTabs = (props: PricingVariableTabsProps) => {
  const { pricingCalculator, pricingExpression } = props

  return (
    <PricingContainer>
      <Tabs defaultActiveTabId={tabIds.expression}>
        <TabsListContainer>
          <TabsListGradient>
            <TabsTriggerGradient label="Cobrança" triggerId={tabIds.expression} />
            <TabsTriggerGradient label="Visualização" triggerId={tabIds.calculator} />
          </TabsListGradient>
        </TabsListContainer>

        <TabsContent triggerId={tabIds.expression}>{pricingExpression}</TabsContent>
        <TabsContent triggerId={tabIds.calculator}>{pricingCalculator}</TabsContent>
      </Tabs>
    </PricingContainer>
  )
}

export default memo(PricingVariableTabs)
